module.exports = __webpack_public_path__ + "img/sala-xpto3.7ad6af0f.jpg";